import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import SeoTagsManager from '../../utils/SeoTagsManager';
import SessionManager from '../../utils/sessionManager';

const CombinedInsuranceResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formValues = SessionManager.getFormValues() || {} } =
    location.state || {};
  const queue = formValues?.comboJourney?.queue || [];

  return (
    <>
      {SeoTagsManager.render('CombinedQuotes')}
      <Container
        maxWidth="md"
        sx={{
          py: { xs: 4, sm: 6, md: 8 },
          px: { xs: 2, sm: 3 },
          overflowX: 'clip',
        }}
      >
        <Box
          sx={{
            borderRadius: '32px',
            border: '1px solid #DCE3E7',
            backgroundColor: '#F8FBFC',
            p: { xs: 3, sm: 4, md: 5 },
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.75rem' },
              lineHeight: 1.05,
              color: '#162F3B',
              mb: 2,
            }}
          >
            Question Flow is complete
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '1rem',
              lineHeight: 1.6,
              color: '#51626B',
              mb: 3,
            }}
          >
            Result Page Pending.
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              color: '#162F3B',
              mb: 1,
            }}
          >
            Selected products
          </Typography>

          <Box sx={{ mb: 4 }}>
            {queue.map((item) => (
              <Typography
                key={item.product}
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1rem',
                  color: '#51626B',
                  mb: 0.5,
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Box>

          <Button
            variant="contained"
            onClick={() => navigate('/online-insurance-quote/step1')}
            sx={{
              display: 'inline-flex',
              mt: 1,
              borderRadius: '20px',
              backgroundColor: '#C7CA00',
              color: '#162F3B',
              textTransform: 'none',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              '&:hover': {
                backgroundColor: '#B7BA00',
              },
            }}
          >
            Start Again
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default CombinedInsuranceResultPage;
